import React from 'react';
import { Controller } from 'react-hook-form';

import {
  FormHelperText,
  MaskedTextField,
  withTitle,
} from '@sbv-clients/ui-shared';
import { Density } from '@sbv-clients/util-misc';

interface FormMaskedTextFieldProps {
  name: string;
  label?: string;
  mask: string;
  fullWidth?: boolean;
  disabled?: boolean;
  density?: Density;
}

const BaseFormMaskedTextField = ({
  name,
  label,
  mask,
  fullWidth,
  disabled,
  density = 'compact',
}: FormMaskedTextFieldProps) => {
  return (
    <Controller
      name={name}
      render={({ field, fieldState }) => (
        <>
          <MaskedTextField
            mask={mask}
            label={label}
            fullWidth={fullWidth}
            disabled={disabled}
            value={field.value ?? ''}
            onChange={field.onChange}
            onBlur={field.onBlur}
            error={Boolean(fieldState.error)}
            slotProps={{
              input: {
                sx: {
                  height: density === 'comfortable' ? '42px' : '100%',
                  boxSizing: 'border-box',
                  alignItems: 'center',
                },
              },
            }}
          />
          {fieldState.error ? (
            <FormHelperText error>{fieldState.error.message}</FormHelperText>
          ) : (
            <FormHelperText>Format: {mask}</FormHelperText>
          )}
        </>
      )}
    />
  );
};

export const FormMaskedTextField = withTitle(BaseFormMaskedTextField);
